import _regeneratorRuntime from "@babel/runtime/helpers/regeneratorRuntime";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
var _span, _LoadingContent;
import { useCallback, useMemo, useState } from 'react';
import { LazyImage } from '@crehana/compass.ui';
import { Popper, PopperAnchor } from '@crehana/compass.ui/v2';
import { CREHANA_BASE_URL_PRD } from '@crehana/constants';
import { getDeviceSO } from '@crehana/utils';
import { clsx } from 'clsx';
import { UserSessionProvider } from "../context/user-session.context";
import { LOGO_TITLE_IMAGE } from "../floating-chat/constants";
import { useRedirect } from "../floating-chat/hooks/use-redirect";
import { HanaHistorialToggleButton } from "../hana-historial-toggle-button/hana-historial-toggle-button";
import { useCopilotCategoriesBanner, useCreateConversationFromChatMessage } from "../hooks";
import { adaptToPrompt } from "../hooks/use-copilot-categories/utils";
import { useUserPermissions } from "../hooks/use-user-permissions";
import { CentralizedUserSessionLayout } from "../layouts/centralized-user-session.layout";
import { PromptTextareaV2 } from "../prompt-textarea-v2/prompt-textarea-v2-container";
import { ErrorContent } from "../shared/components/error-content";
import { HanaDisclaimer } from "../shared/components/hana-disclaimer";
import { TargetSegmentEnum } from "../shared/types";
import { CategoryFilter } from "./components/category-filter";
import { LoadingContent } from "./components/loading-content";
import { HIDDEN_CHIPS_SLUGS } from "./constants/hidden-chips-slugs";
import { itemsCategories } from "./constants/mock-data";
import { useAddI18nLocales, useBannerCategoriesTranslation } from "./i18n";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var HanaBannerCategoriesContent = function HanaBannerCategoriesContent(_ref) {
  var _ErrorContent;
  var onChatCreation = _ref.onChatCreation,
    _ref$loading = _ref.loading,
    loading = _ref$loading === void 0 ? false : _ref$loading,
    _ref$error = _ref.error,
    error = _ref$error === void 0 ? false : _ref$error,
    _ref$targetSegment = _ref.targetSegment,
    targetSegment = _ref$targetSegment === void 0 ? TargetSegmentEnum.EndUser : _ref$targetSegment,
    _ref$isFullWidth = _ref.isFullWidth,
    isFullWidth = _ref$isFullWidth === void 0 ? false : _ref$isFullWidth,
    hidePromptChips = _ref.hidePromptChips;
  var _useState = useState(function () {
      return getDeviceSO();
    }),
    _useState2 = _slicedToArray(_useState, 1),
    deviceInfo = _useState2[0];
  var isIOS = deviceInfo.isIOS;
  useAddI18nLocales();
  var _useBannerCategoriesT = useBannerCategoriesTranslation(),
    t = _useBannerCategoriesT.t;
  var _useUserPermissions = useUserPermissions({}),
    _useUserPermissions$c = _useUserPermissions.centralizedOrganizationId,
    centralizedOrganizationId = _useUserPermissions$c === void 0 ? 0 : _useUserPermissions$c,
    _useUserPermissions$l = _useUserPermissions.learningOrganizationId,
    learningOrganizationId = _useUserPermissions$l === void 0 ? 0 : _useUserPermissions$l,
    _useUserPermissions$s = _useUserPermissions.slug,
    slug = _useUserPermissions$s === void 0 ? '' : _useUserPermissions$s;
  var shouldHideChips = hidePromptChips !== null && hidePromptChips !== void 0 ? hidePromptChips : HIDDEN_CHIPS_SLUGS.includes(slug);
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    selectedItem = _useState4[0],
    setSelectedItem = _useState4[1];
  var _useState5 = useState(),
    _useState6 = _slicedToArray(_useState5, 2),
    selectedTopic = _useState6[0],
    setSelectedTopic = _useState6[1];
  var _useCreateConversatio = useCreateConversationFromChatMessage({
      organizationId: learningOrganizationId,
      slug: slug,
      role: targetSegment
    }),
    submitPromptAndGetConversation = _useCreateConversatio.submitPromptAndGetConversation;
  var _useCopilotCategories = useCopilotCategoriesBanner({
      role: targetSegment,
      centralizedId: centralizedOrganizationId
    }),
    apiCategories = _useCopilotCategories.categories,
    adaptedCategories = _useCopilotCategories.adaptedCategories,
    loadingCategories = _useCopilotCategories.loading,
    errorCategories = _useCopilotCategories.error,
    refetch = _useCopilotCategories.refetch;
  var formattedItems = useMemo(function () {
    return apiCategories.flatMap(function (category) {
      return category.copilot_prompts.filter(function (prompt) {
        return prompt.name && category.name;
      }).map(function (prompt) {
        return {
          label: prompt.name || '',
          category: category.name || '',
          id: category.id || ''
        };
      });
    });
  }, [apiCategories]);
  var formattedItemsInputPlaceholder = useMemo(function () {
    // biome-ignore lint/style/useBlockStatements: single-line early return
    if (!(apiCategories !== null && apiCategories !== void 0 && apiCategories.length)) return [];
    var items = apiCategories.flatMap(function (category) {
      return category.copilot_prompts.map(function (prompt) {
        return {
          label: prompt.name || '',
          category: category.name || ''
        };
      });
    });
    return items;
  }, [apiCategories]);
  var onSelectItem = useCallback(function (item) {
    setSelectedItem(item);
    setSelectedTopic({
      category: item.category,
      name: item.label,
      prompt: item.label,
      suggestions: []
    });
  }, []);
  var onSubmitPrompt = useCallback(/*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref2) {
      var prompt, id;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            prompt = _ref2.prompt;
            _context.prev = 1;
            _context.next = 4;
            return submitPromptAndGetConversation({
              prompt: prompt,
              isExternal: true
            });
          case 4:
            id = _context.sent;
            if (id) {
              onChatCreation(id);
            }
            _context.next = 11;
            break;
          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](1);
            console.error('Failed to start conversation', _context.t0);
          case 11:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 8]]);
    }));
    return function (_x) {
      return _ref3.apply(this, arguments);
    };
  }(), [submitPromptAndGetConversation, onChatCreation]);
  var defaultIcon = useMemo(function () {
    var _ref4 = selectedItem || {},
      icon = _ref4.icon;
    // biome-ignore lint/style/useBlockStatements: single-line early return
    if (!(icon !== null && icon !== void 0 && icon.Component)) return undefined;
    return /*#__PURE__*/_jsx(icon.Component, {
      size: 24,
      className: icon.className
    });
  }, [selectedItem]);
  var _useRedirect = useRedirect({
      slug: slug,
      viewMode: targetSegment
    }),
    handleRedirect = _useRedirect.handleRedirect;

  // biome-ignore lint/correctness/useExhaustiveDependencies: dependencies are intentional
  var Content = useMemo(function () {
    return /*#__PURE__*/_jsx(Popper, {
      children: /*#__PURE__*/_jsxs("div", {
        className: "tw-w-full tw-flex tw-flex-col tw-gap-2.4",
        children: [/*#__PURE__*/_jsxs("div", {
          className: "tw-flex tw-justify-between",
          children: [/*#__PURE__*/_jsxs("div", {
            className: "tw-flex tw-gap-1.2 tw-items-center",
            children: [/*#__PURE__*/_jsx("div", {
              className: "tw-w-10.4 tw-h-3.6 tw-relative",
              children: /*#__PURE__*/_jsx(LazyImage, {
                src: LOGO_TITLE_IMAGE,
                placeholder: LOGO_TITLE_IMAGE,
                imgxParams: {
                  fit: 'crop',
                  h: '100%',
                  w: '100%',
                  crop: 'faces'
                },
                alt: 'Crehana ai logo',
                imgClassName: "tw-w-full tw-h-full tw-object-contain",
                className: "tw-w-full tw-h-full"
              })
            }), _span || (_span = /*#__PURE__*/_jsx("span", {
              className: "tw-font-caption tw-text-[#140058] tw-flex tw-items-center tw-justify-center tw-text-1.2 tw-px-1.2 tw-py-0.4 tw-bg-gradient-to-r tw-from-[#D6FD6A] tw-to-transparent tw-rounded-full",
              children: "Beta"
            }))]
          }), /*#__PURE__*/_jsx(HanaHistorialToggleButton, {
            label: t('LABEL_HANA_WIDGET_VIEW_HISTORY_BUTTON'),
            onClick: handleRedirect,
            buttonClassName: "tw-border tw-border-solid tw-border-neutral-light-400"
          })]
        }), /*#__PURE__*/_jsx("div", {
          className: "tw-flex tw-justify-center tw-w-full",
          children: /*#__PURE__*/_jsxs("div", {
            id: "hana-search-container",
            className: "tw-flex tw-gap-2.4 tw-relative tw-w-full tw-flex-col",
            children: [/*#__PURE__*/_jsx(PopperAnchor, {
              children: /*#__PURE__*/_jsx(PromptTextareaV2, {
                placeholder: t('MAIN_CHAT_LABEL_PLACEHOLDER_TEXTAREA'),
                className: "tw-h-[10rem]",
                promptClassName: clsx('tw-h-7.2 tw-max-h-7.2', {
                  'tw-font-body2': isIOS,
                  'tw-font-body4': !isIOS
                }),
                showSubmitButton: true,
                submitButtonVerticalAlign: "bottom",
                onSubmitPrompt: onSubmitPrompt,
                defaultPrompt: selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.label,
                selectedTopic: selectedTopic,
                categories: adaptToPrompt(itemsCategories)
              })
            }), !shouldHideChips && /*#__PURE__*/_jsxs("div", {
              className: "tw-flex tw-flex-col tw-gap-1",
              children: [/*#__PURE__*/_jsx("p", {
                className: "tw-font-body4 tw-text-neutral-light-700",
                children: t('LABEL_HANA_WIDGET_BANNER_CATEGORIES_TITLE')
              }), /*#__PURE__*/_jsx("div", {
                className: "tw-max-h-[150px] tw-overflow-y-auto",
                children: /*#__PURE__*/_jsx(CategoryFilter, {
                  adaptedCategories: adaptedCategories || [],
                  onSelectItem: onSelectItem,
                  selectedItem: selectedItem,
                  targetSegment: targetSegment
                })
              })]
            })]
          })
        }), /*#__PURE__*/_jsx("div", {
          className: "tw-flex tw-justify-center tw-w-full",
          children: /*#__PURE__*/_jsx(HanaDisclaimer, {
            show: true,
            linkText: t('LABEL_FOOTER_TEXT_SHORTER'),
            linkHref: "".concat(CREHANA_BASE_URL_PRD, "/legal/politicas-de-privacidad/")
          })
        })]
      })
    });
  }, [t, isFullWidth, onSubmitPrompt, selectedItem, selectedTopic, formattedItemsInputPlaceholder, onSelectItem, formattedItems, defaultIcon, shouldHideChips]);
  var renderContent = function renderContent() {
    var shouldWaitForCategories = !shouldHideChips;
    if (loading || shouldWaitForCategories && loadingCategories) {
      return _LoadingContent || (_LoadingContent = /*#__PURE__*/_jsx(LoadingContent, {}));
    }
    if (error || shouldWaitForCategories && errorCategories) {
      return _ErrorContent || (_ErrorContent = /*#__PURE__*/_jsx(ErrorContent, {
        onRetry: refetch
      }));
    }
    return Content;
  };
  return /*#__PURE__*/_jsxs("div", {
    className: "tw-h-full tw-overflow-hidden tw-relative tw-w-full tw-min-h-[28.4rem] tw-flex tw-justify-center tw-items-center tw-flex-col tw-px-3.2 tw-py-2 tw-rounded-1.6 tw-border tw-border-solid tw-border-neutral-light-400",
    children: [/*#__PURE__*/_jsx("div", {
      className: "tw-z-1 tw-w-full",
      children: renderContent()
    }), /*#__PURE__*/_jsx("div", {
      className: "tw-absolute tw-top-0 tw-left-0 tw-w-full tw-h-full tw-z-0 tw-bg-neutral-light-100",
      children: /*#__PURE__*/_jsx("div", {
        className: "tw-w-full tw-h-full",
        style: {
          background: 'radial-gradient(50% 80% at 0% 0%, rgba(214,253,106,0.36) 15.87%, rgba(247,247,247,0.00) 100%), rgba(247,247,247,0)'
        }
      })
    })]
  });
};
export var HanaBannerCategories = function HanaBannerCategories(_ref5) {
  var onChatCreation = _ref5.onChatCreation,
    _ref5$loading = _ref5.loading,
    loading = _ref5$loading === void 0 ? false : _ref5$loading,
    _ref5$error = _ref5.error,
    error = _ref5$error === void 0 ? false : _ref5$error,
    targetSegment = _ref5.targetSegment,
    _ref5$isFullWidth = _ref5.isFullWidth,
    isFullWidth = _ref5$isFullWidth === void 0 ? false : _ref5$isFullWidth,
    hidePromptChips = _ref5.hidePromptChips;
  var _useUserPermissions2 = useUserPermissions({}),
    isUserSessionValid = _useUserPermissions2.isUserSessionValid,
    canAccessHanaAI = _useUserPermissions2.canAccessHanaAI;
  if (!isUserSessionValid || !canAccessHanaAI) {
    return null;
  }
  return /*#__PURE__*/_jsx(CentralizedUserSessionLayout, {
    children: /*#__PURE__*/_jsx(UserSessionProvider, {
      children: /*#__PURE__*/_jsx(HanaBannerCategoriesContent, {
        loading: loading,
        error: error,
        onChatCreation: onChatCreation,
        targetSegment: targetSegment,
        isFullWidth: isFullWidth,
        hidePromptChips: hidePromptChips
      })
    })
  });
};